import { render, staticRenderFns } from "./TabTypeSettingOptions.vue?vue&type=template&id=69529a08&scoped=true&"
import script from "./TabTypeSettingOptions.vue?vue&type=script&lang=js&"
export * from "./TabTypeSettingOptions.vue?vue&type=script&lang=js&"
import style0 from "./TabTypeSettingOptions.vue?vue&type=style&index=0&id=69529a08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69529a08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems})
